import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AppBannerContainer from '../AppBannerContainer';
import MobileInviteBannerContainer from '../MobileInviteBannerContainer';
import { hasVariant } from '../../selectors/configSelectors';
import { MVT_1068 } from '../../flags/experiments';

function MobileBanners({ isMgmBanner, inviteLink, page }) {
  if (isMgmBanner && !!inviteLink) {
    return <MobileInviteBannerContainer />;
  }

  return <AppBannerContainer page={page} />;
}

MobileBanners.propTypes = {
  isMgmBanner: PropTypes.bool.isRequired,
  inviteLink: PropTypes.string,
  page: PropTypes.string.isRequired,
};

MobileBanners.defaultProps = {
  inviteLink: undefined,
};

export default connect((state) => ({
  isMgmBanner: hasVariant(state, MVT_1068, 'mgm_banner'),
  inviteLink: state.user.roovite.link,
}))(MobileBanners);
